import { Controller } from "@hotwired/stimulus"

// Identification du Prestataire : la même colonne stocke un nom de personne
// OU une dénomination sociale selon le statut. Les libellés doubles
// (« Nom et prénom, ou dénomination ») forçaient chacun à deviner sa moitié.
// Ici le statut se choisit d'abord, et les libellés disent exactement quoi
// remplir pour CE statut. Sans statut choisi : les champs se rangent derrière
// une ligne qui demande de choisir. (24/09/2026 : le choix « pas encore de
// société » est retiré, le coach sans société coche « Je travaille seul ».)
// 27/09/2026 : « Je travaille seul » devient deux choix, sans et avec
// matricule fiscal. Sans matricule, ni champ matricule ni section patente.
const TEXTES = {
  sans_matricule: {
    nom: "Nom et prénom (comme sur votre carte d'identité)",
    fiscal: "",
    aideFiscal: "",
    cin: true,
    sansMatricule: true,
    adresse: "Votre adresse postale complète"
  },
  avec_matricule: {
    nom: "Nom et prénom (comme sur votre carte d'identité)",
    fiscal: "Matricule fiscal",
    aideFiscal: "",
    cin: true,
    adresse: "Votre adresse postale complète"
  },
  auto_entrepreneur: {
    nom: "Nom et prénom (comme sur votre carte d'identité)",
    fiscal: "Matricule fiscal (si vous en avez un)",
    aideFiscal: "Laissez vide si vous n'en avez pas : la CIN et le numéro d'auto-entrepreneur suffisent.",
    adresse: "Votre adresse postale complète",
    cin: true,
    ae: true
  },
  company: {
    nom: "Dénomination sociale (le nom officiel de la société)",
    fiscal: "Matricule fiscal ou identifiant RNE de la société",
    aideFiscal: "Tel qu'il figure sur l'extrait RNE ou la carte d'identification fiscale de la société.",
    adresse: "Adresse du siège social",
    cin: false
  }
}

export default class extends Controller {
  static targets = ["libelleNom", "libelleFiscal", "aideFiscal", "libelleAdresse",
                    "champs", "panneauSansStatut", "blocCin", "blocAe", "blocFiscal"]

  connect() { this.actualiser() }

  actualiser() {
    const coche = this.element.querySelector('input[type="radio"][name$="[situation]"]:checked')
    const statut = coche ? coche.value : ""
    const textes = TEXTES[statut]

    if (!textes) {
      this.champsTarget.hidden = true
      this.panneauSansStatutTarget.hidden = false
      return
    }

    this.champsTarget.hidden = false
    this.panneauSansStatutTarget.hidden = true
    this.libelleNomTarget.textContent = textes.nom
    this.libelleFiscalTarget.textContent = textes.fiscal
    this.aideFiscalTarget.textContent = textes.aideFiscal
    this.libelleAdresseTarget.textContent = textes.adresse
    // Une société n'a pas de CIN : le champ ne sert qu'aux personnes.
    if (this.hasBlocCinTarget) this.blocCinTarget.hidden = !textes.cin
    // Le numéro d'auto-entrepreneur ne concerne que l'auto-entrepreneur
    // (24/09/2026 : il vivait avant dans la carte « Retenue à la source »).
    if (this.hasBlocAeTarget) this.blocAeTarget.hidden = !textes.ae
    if (this.hasBlocFiscalTarget) this.blocFiscalTarget.hidden = !!textes.sansMatricule
    // La section patente vit hors du formulaire (elle a le sien) : sans
    // matricule, elle disparaît ; avec, elle apparaît sans attendre.
    const patente = document.getElementById("patente")
    if (patente) patente.hidden = !!textes.sansMatricule
  }
}
